import script from "./GuestBook.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestBook.vue?vue&type=script&setup=true&lang=js"

import "./GuestBook.vue?vue&type=style&index=0&id=464db985&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464db985"]])

export default __exports__